export const zodiacNames = ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪']
export function zodiacMapping(year) {
  const mapping = Object.fromEntries(zodiacNames.map(name => [name, []]))
  if (!Number.isInteger(Number(year)) || Number(year) < 2024 || Number(year) > 2050) return mapping
  for (let number = 1; number <= 49; number++) mapping[zodiacNames[((Number(year) - 4) % 12 - (number - 1) % 12 + 12) % 12]].push(number)
  return mapping
}
const reds = new Set([1, 2, 7, 8, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46])
const blues = new Set([3, 4, 9, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48])
export const numberColor = value => reds.has(Number(value)) ? 'red' : blues.has(Number(value)) ? 'blue' : 'green'
export function shortcutNumbers({ color, kind, value, mapping } = {}) {
  return Array.from({ length: 49 }, (_, index) => index + 1).filter(number => {
    if (color && numberColor(number) !== color) return false
    if (kind === 'odd') return number % 2 === 1
    if (kind === 'even') return number % 2 === 0
    // Match the existing TMA big/small rule: 49 refunds, so it belongs to neither.
    if (kind === 'big') return number >= 25 && number <= 48
    if (kind === 'small') return number <= 24
    if (kind === 'head') return Math.floor(number / 10) === Number(value)
    if (kind === 'tail') return number % 10 === Number(value)
    if (kind === 'zodiac') return Array.isArray(mapping?.[value]) && mapping[value].includes(number)
    return true
  })
}
